export function createQrPolling(options = {}) {
  let timer = null
  let isPolling = false
  let pending = false // 防并发重复请求
  const {
    interval = 2000, // 轮询间隔
    request, // 调用真实接口
    isSuccess, // 判断轮询是否成功
    callback = () => {}, // 轮询成功后回调
    onSuccess = () => {}, //  成功后业务处理
    onError = () => {} // 错误处理
  } = options

  async function pollingTask() {
    if (!isPolling || pending) return
    try {
      pending = true
      const res = await request()
      callback?.(res)
      //  判断是否成功
      if (isSuccess && isSuccess(res)) {
        stop()
        onSuccess(res)
      }
    } catch (err) {
      onError && onError(err)
    } finally {
      pending = false
    }
  }

  function start() {
    if (isPolling) return
    isPolling = true
    // 立即执行一次
    pollingTask()
    timer = setInterval(pollingTask, interval)
  }

  function stop() {
    isPolling = false
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }
  return {
    start,
    stop
  }
}
